class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

        // Bind tab clicks
        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener('click', this.tabActive.bind(this));
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener('click', this.tabToggle.bind(this));
        }

        // Save global click handler
        this.onDocumentClick = (e) => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e);
            } else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e);
                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e);
                }
            }
        };
        document.addEventListener('click', this.onDocumentClick);

        // Background overlay click
        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            this.overlay = document.querySelector('.background-overlay');
            this.overlay?.addEventListener('click', this.onBackgroundClick.bind(this));
        }

        setTimeout(() => {
            if (window.innerWidth > 550) {
                const $thisContent = document.getElementById('tab-description-mobile');
                const tabHeight = $thisContent?.offsetHeight;
                const maxHeight = parseInt($thisContent?.querySelector('.tab-showMore')?.dataset.desMax);
                if (tabHeight && maxHeight && tabHeight < maxHeight) {
                    $thisContent.querySelector('.tab-showMore')?.remove();
                }
            }
        });
    }
    
    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.target;
        const id = $this.getAttribute('href').replace('#', '');
        const button_tab = document.querySelector('.an-horizontal-shaking');

        if (!$this.classList.contains('is-open')) {
            this.tab.forEach(el => el.classList.remove('is-open'));
            $this.classList.add('is-open');
            this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach(el => {
                el.id === id ? el.classList.add('is-active') : el.classList.remove('is-active');
            });
        }   

        if ($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const $this = event.currentTarget;
        const $thisContent = $this.parentNode.nextElementSibling;

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {
            $($thisContent).toggleClass('is-show');
        } else if (window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {
            $this.classList.remove('is-open', 'show-mobile');
            $($thisContent).slideUp('slow');
        } else if ($this.classList.contains('is-open')) {
            $this.classList.remove('is-open');
            if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                $thisContent.classList.remove('is-show');
                document.body.classList.remove('tab-popup-show');
            } else {
                $($thisContent).slideUp('slow');
            }
        } else {
            $this.classList.add('is-open');
            if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
                document.body.classList.add('tab-popup-sidebar-show');
                $thisContent.classList.add('is-show');
                document.body.classList.add('tab-popup-show');
            } else {
                $($thisContent).slideDown('slow');
            }
        }
    }

    readMoreReadLess(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.target.closest('[data-show-more-toogle]');
        const id = $this.getAttribute('href').replace('#', '');
        const textShowMore = $this.getAttribute('data-show-more-text');
        const textShowLess = $this.getAttribute('data-show-less-text');
        const desMax = $this.closest('.tab-showMore').dataset.desMax;
        const content = document.getElementById(id);

        if ($this.classList.contains('is-less')) {
            $this.closest('.tab-showMore').classList.remove('is-less', 'is-show');
            $this.classList.remove('is-less', 'is-show');
            $this.closest('.tab-showMore').classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            content.style.maxHeight = `${desMax}px`;
            this.tabContents.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        } else {
            $this.closest('.tab-showMore').classList.remove('is-show');
            $this.classList.remove('is-show');
            $this.closest('.tab-showMore').classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            content.style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents.classList.remove('is-show');
        this.tab.forEach(el => el.classList.remove('is-open'));
        document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        this.tabContent.forEach(el => el.classList.remove('is-active'));

        if (window.innerWidth <= 551) {
            event.target.closest('.toggle-content')?.classList.remove('is-show');
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            const $thisContent = document.getElementById(id);
            const tabHeight = $thisContent?.offsetHeight;
            const maxHeight = parseInt($thisContent?.querySelector('.tab-showMore')?.dataset.desMax);
            if (tabHeight && maxHeight && tabHeight < maxHeight) {
                $thisContent.querySelector('.tab-showMore')?.remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (event.target.closest('toggle-content.is-show')) return;
        document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event) {
        const icon = event.target;
        icon.closest('.toggle-content')?.classList.remove('is-show');
        icon.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open');
        document.body.classList.remove('tab-popup-show');
    }

    // CLEANUP: Remove global listeners when component is removed
    disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.overlay?.removeEventListener('click', this.onBackgroundClick);
    }
}

customElements.define('product-tab', ProductTabs);